import React from "react"

import CardGrid from "areas/landing/elements/landing-card-grid"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const gridCardStyle = {
  card_style: {
    bg: "blackPrint",
    color: "white",
  },
  cta_style: {
    color: "white",
  },
  description_style: {},
  label_style: {
    textTransform: "uppercase",
  },
}

const getCardGridData = () => ({
  anchor_name: "create-something-special",
  contain: true,
  data: {
    items: [
      {
        cta: "Shop Now",
        image: {
          alt: "Best Sellers",
          fallback:
            "https://cms.jewlr.com/card_best_sellers_2x_06651fd756/card_best_sellers_2x_06651fd756.jpg",
          srcSet: [
            {
              height: 408,
              media: "(max-width: 767px)",
              sizes: "(max-width: 767px) 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_card_best_sellers_2x_bcdfb097a2/m_card_best_sellers_2x_bcdfb097a2.jpg`,
                335
              ),
              width: 335,
            },
            {
              height: 840,
              media: "(min-width: 768px) and (max-width: 1023px)",
              sizes: "(max-width: 1023px) 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_best_sellers_2x_06651fd756/card_best_sellers_2x_06651fd756.jpg`,
                840
              ),
              width: 840,
            },
            {
              height: 840,
              media: "(min-width: 1024px)",
              sizes: "(max-width: 1920px) 25vw, 470px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_best_sellers_2x_06651fd756/card_best_sellers_2x_06651fd756.jpg`,
                840
              ),
              width: 840,
            },
          ],
          style: {},
          title: "Best Sellers",
          url: "/best-sellers-for-her",
        },
        label: "Best Sellers",
        style: gridCardStyle,
        url: "/best-sellers-for-her",
      },
      {
        cta: "Shop Now",
        image: {
          alt: "For Her",
          fallback:
            "https://cms.jewlr.com/card_for_her_2x_5f67a38acc/card_for_her_2x_5f67a38acc.jpg",
          srcSet: [
            {
              height: 408,
              media: "(max-width: 767px)",
              sizes: "(max-width: 767px) 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_card_for_her_2x_6279e11a86/m_card_for_her_2x_6279e11a86.jpg`,
                335
              ),
              width: 335,
            },
            {
              height: 840,
              media: "(min-width: 768px) and (max-width: 1023px)",
              sizes: "(max-width: 1023px) 25vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_for_her_2x_5f67a38acc/card_for_her_2x_5f67a38acc.jpg`,
                840
              ),
              width: 840,
            },
            {
              height: 840,
              media: "(min-width: 1024px)",
              sizes: "(max-width: 1920px) 25vw, 470px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_for_her_2x_5f67a38acc/card_for_her_2x_5f67a38acc.jpg`,
                840
              ),
              width: 840,
            },
          ],
          style: {},
          title: "For Her",
          url: `/${jewlr_t("terms.jewelry")}-for-her`,
        },
        label: "For Her",
        style: gridCardStyle,
        url: `/${jewlr_t("terms.jewelry")}-for-her`,
      },
      {
        cta: "Shop Now",
        image: {
          alt: "For Him",
          fallback:
            "https://cms.jewlr.com/card_for_him_2x_32667f1f88/card_for_him_2x_32667f1f88.jpg",
          srcSet: [
            {
              height: 408,
              media: "(max-width: 767px)",
              sizes: "(max-width: 767px) 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_card_for_him_2x_ab9fc27f5c/m_card_for_him_2x_ab9fc27f5c.jpg`,
                335
              ),
              width: 335,
            },
            {
              height: 840,
              media: "(min-width: 768px) and (max-width: 1023px)",
              sizes: "(max-width: 1023px) 25vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_for_him_2x_32667f1f88/card_for_him_2x_32667f1f88.jpg`,
                840
              ),
              width: 840,
            },
            {
              height: 840,
              media: "(min-width: 1024px)",
              sizes: "(max-width: 1920px) 25vw, 470px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_for_him_2x_32667f1f88/card_for_him_2x_32667f1f88.jpg`,
                840
              ),
              width: 840,
            },
          ],
          style: {},
          title: "For Him",
          url: `/${jewlr_t("terms.jewelry")}-for-him`,
        },
        label: "For Him",
        style: gridCardStyle,
        url: `/${jewlr_t("terms.jewelry")}-for-him`,
      },
      {
        cta: "Shop Now",
        image: {
          alt: "What’s New",
          fallback:
            "https://cms.jewlr.com/card_whats_new_2x_d4105fc028/card_whats_new_2x_d4105fc028.jpg",
          srcSet: [
            {
              height: 408,
              media: "(max-width: 767px)",
              sizes: "(max-width: 767px) 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_card_whats_new_2x_25063d1dc5/m_card_whats_new_2x_25063d1dc5.jpg`,
                335
              ),
              width: 335,
            },
            {
              height: 840,
              media: "(min-width: 768px) and (max-width: 1023px)",
              sizes: "(max-width: 1023px) 25vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_whats_new_2x_d4105fc028/card_whats_new_2x_d4105fc028.jpg`,
                840
              ),
              width: 840,
            },
            {
              height: 840,
              media: "(min-width: 1024px)",
              sizes: "(max-width: 1920px) 25vw, 470px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/card_whats_new_2x_d4105fc028/card_whats_new_2x_d4105fc028.jpg`,
                840
              ),
              width: 840,
            },
          ],
          style: {},
          title: "What’s New",
          url: "/new-items",
        },
        label: "What’s New",
        style: gridCardStyle,
        url: "/new-items",
      },
    ],
  },
  style: {
    block_style: {},
  },
})

const CreatSomethingSpecial = () => <CardGrid element={getCardGridData()} />

export default CreatSomethingSpecial
